import React from 'react';
import {render, unmountComponentAtNode} from 'react-dom';
import LoginModal from '../modals/login/LoginModal';
import ViewUtil from './../ViewUtil';


export default function showLoginDialog(actionName: string) {
  return new Promise(resolve => {
    const div = document.createElement('div');
    document.body.appendChild(div);

    render((
      <LoginModal
        onSuccess={(success, component) => {
          if (success) {
            if (ViewUtil.isDirectLinkToCollection()) {
              ViewUtil.removeArg('collection');
            }
            window.render();
          }

          component.hide();

          setTimeout(() => {
            unmountComponentAtNode(div);
            document.body.removeChild(div);
            resolve(success);
          }, 50);
        }}
        onError={(err) => {
          console.error(err);
          resolve(false);
        }} />
    ), div);
  });
}